export var SELU_SCALEALPHA = 1.7580993408473768599402175208123;
export var SELU_SCALE = 1.0507009873554804934193349852946;
//# sourceMappingURL=selu_util.js.map